import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';

function AnnotationField({field, handleChange, currentValue, disabled, title_additional_message=null}) {
  // Fallback value for checkbox type
  const fallback = field.type === 'checkbox' ? false : '';
  const [value, setValue] = useState(currentValue ?? fallback);
  const [additionalMessage,setAdditionalMessage] = useState(title_additional_message); // Additional message

  // Update value when props change
  useEffect(() => {
    // Update locally only if necessary
    // Thanks to this condition, when the user changes manually the output, the cursor position apparently is not wrongly updated
    // Otherwise, each time the user press a key, the cursor goes at the end of the text
    if (currentValue != value) {
      setValue(currentValue ?? fallback);
    }
  }, [currentValue]);
  useEffect(() => {
    setAdditionalMessage(title_additional_message);
  }, [title_additional_message]);

  // When an input value changes, we tell the parent it has changed
  // It's up to the parent to change the value accordingly
  const localHandleChange = (e) => {
    const target = e.target;
    const v = target.type === 'checkbox' ? target.checked : target.value;
    setValue(v); // update locally
    handleChange(v) // tell the parent about the change
  }

  // HTML depending on the type of field
  switch(field.type){
    case "select":
      return <div>
        <h5 className="title">{field.title} {additionalMessage && <span className="additional_message">({additionalMessage})</span>}</h5>
        <select onChange={localHandleChange} value={value} disabled={disabled}>
          {field.options.map(({id,text}) => <option key={"option_" + id} value={id}>{text}</option>)}        
        </select>
      </div>
    case "number":
      return <div>
        <h5 className="title">{field.title} {additionalMessage && <span className="additional_message">({additionalMessage})</span>}</h5>
        <input onChange={localHandleChange} type="number" min={field.min} max={field.max} value={value} disabled={disabled}/>
      </div>
    case "text":
      return <div>
        <h5 className="title">{field.title} {additionalMessage && <span className="additional_message">({additionalMessage})</span>}</h5>
        <input onChange={localHandleChange} type="text" value={value} disabled={disabled}/>
      </div>
    case "checkbox":
      return <div>
        <h5 className="title">{field.title} {additionalMessage && <span className="additional_message">({additionalMessage})</span>}</h5>
        <input onChange={localHandleChange} type="checkbox" checked={value === true} disabled={disabled}/>
      </div>
    case "date":
      return <div>
        <h5 className="title">{field.title} {additionalMessage && <span className="additional_message">({additionalMessage})</span>}</h5>
        <input onChange={localHandleChange} type="date" value={value} disabled={disabled}/>
      </div>      
    case "datetime-local":
      return <div>
        <h5 className="title">{field.title} {additionalMessage && <span className="additional_message">({additionalMessage})</span>}</h5>
        <input onChange={localHandleChange} type="datetime-local" value={value} disabled={disabled}/>
      </div> 
    case "email":
      return <div>
        <h5 className="title">{field.title} {additionalMessage && <span className="additional_message">({additionalMessage})</span>}</h5>
        <input onChange={localHandleChange} type="email" value={value} disabled={disabled}/>
      </div> 
    case "textarea":
      return <div>
        <h5 className="title">{field.title} {additionalMessage && <span className="additional_message">({additionalMessage})</span>}</h5>
        <textarea onChange={localHandleChange} rows="5" cols="40" value={value} disabled={disabled}></textarea>
      </div>

    default:
      return <div></div>
  }
}

export default AnnotationField;